import { atom } from "jotai";
import { graphql, readInlineData } from "react-relay";

import type { atomsCurrentArticleAtomBase$key } from "scmp-app/queries/__generated__/atomsCurrentArticleAtomBase.graphql";
import type { hooksTrackCurrentItemBase$data } from "scmp-app/queries/__generated__/hooksTrackCurrentItemBase.graphql";

export const currentItemAtom = atom<hooksTrackCurrentItemBase$data | null>(null);

export const currentArticleAtom = atom(get => {
  const currentItem = get(currentItemAtom);
  if (!currentItem) return;

  const item = readInlineData<atomsCurrentArticleAtomBase$key>(
    graphql`
      fragment atomsCurrentArticleAtomBase on BaseWithApplicationAndUrlAlias
      @inline
      @argumentDefinitions(
        customContents: { type: "[CustomContentInput]", defaultValue: [] }
        bodyType: { type: "BodyFormatTypeEnum", defaultValue: PARAGRAPH }
      ) {
        __typename
        ... on Article {
          ...articleHeadlineHeaderFeaturesArticle
          ...articleSeoArticle @arguments(customContents: $customContents, bodyType: $bodyType)
          ...bookmarkHeaderFeaturesArticle
          ...commentHeaderFeaturesArticle
          ...contentShareWidgetContent
          ...bookmarkHeaderFeaturesArticle
          ...commentHeaderFeaturesArticle
          ...helpersCheckIsStyleArticle
          ...helpersUseSharingUrl
          ...articleShareWidgetArticle
          ...hooksTrackPageViewArticle
          ...hooksContentInterestArticle
          ...hooksUseCurrentArticleIdsArticle
          ...hooksUseCurrentArticlePrebidConfigArticle
          ...hooksUsePageTargetingArticle
          ...onboardingNewsletterSubscriptionArticle
          ...sectionHeaderFeaturesArticle
          ...shareHeaderFeaturesContent
          ...abandonedCartOfferDialogArticle
        }
      }
    `,
    currentItem,
  );

  switch (item.__typename) {
    case "%other":
      return;
    case "Article":
      return item;
  }
});
